import $ from 'jquery';

class Hero {
    constructor() {
        this.slider = $('.locations-carousel-slider-for');        
    }

    init() {
        this.handleImageModal(); 
        this.handleModalCarousel();         
    }

    handleImageModal() {
        //open carousel modal
        $('body').on('click', '.locations-more', () => {
            const api = this.slider.slick('getSlick');
            api.slickGoTo(0);
            this.openGalleryModal();
        });

        $('body').on('click', '.carousel-item-copy', (e) => {
            let selectedSlide = $(e.target).attr('data-index');     
            const api = this.slider.slick('getSlick');       
            api.slickGoTo(selectedSlide);
            this.openGalleryModal();
        });

        //close carousel modal
        $(document).on('click', (e) => {
			if ($(e.target).hasClass('modaal-outer-wrapper')) {
                $('#locations-carousel-modal').modaal('close');
			}
		});  
    }

    handleModalCarousel() {
        $('.locations-carousel-slider-for').slick({
            slidesToShow: 1,
            arrows: true,
            infinite: true,
            fade: false,
            centerMode: false,
            adaptiveHeight: false,
            draggable: true,    
            asNavFor: '.locations-carousel-slider-nav',
            initialSlide: 1,
            responsive: [
                {
                    breakpoint: 860,
                    settings: {
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        draggable: true,
                        fade: true,
                        focusOnSelect: true,
                    }
                }
            ],
        });  

        $('.locations-carousel-slider-nav').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.locations-carousel-slider-for',
            dots: false,
            arrows: false,
            focusOnSelect: true,
            mobileFirst: true,
            adaptiveHeight: true,
            centerMode: false,            
            responsive: [
                {
                    breakpoint: 860,
                    settings: {
                        slidesToShow: 6,
                        centerMode: false,
                    }
                }
            ],
        });      
    }


    openGalleryModal() {
        $('#locations-carousel-modal').modaal({
            content_source: '#locations-carousel-modal',
            overlay_opacity: 0.6,
            custom_class: 'locations-carousel-modal',
            width: 780  
        });
        $('#locations-carousel-modal').modaal('open');
    }
}

export default Hero;

$(() => {
	const hero = new Hero();
	hero.init();
});